import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import env from './configs/env'

Vue.config.productionTip = false

// 全局初始化css
import 'normalize.css/normalize.css'

// 引入element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

//引入jsonp 用于腾讯地图跨域问题
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

// 引入二次封装的element table
import Table from '@/components/table'
Vue.component('Table', Table)

// 全局引用nav 组件
import Nav from '@/components/nav'
Vue.component('Nav', Nav)

// 引入全局scss
import '@/styles/index.scss'

// 粒子动画
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

window.$imgUrl = env.qnImgDomain

// 导入验证码js
require('./utils/verify-code.min.js')


/**
 * 按钮全新控制
 *authorities 多个用,号隔开
 * v-show="hasAuthority('systemUserCreate')"
 * v-show="hasAuthority('systemUserCreate,systemUserUpdate,')"
 * @returns {boolean}
 */
Vue.prototype.hasAuthority = function (authorities) {
  let list = JSON.parse(sessionStorage.getItem('btnAccessList'))
  if (!authorities) {
    return false
  }
  return authorities.split(',').some(item => {
    return list.includes(item)
  })
}

Vue.use(ElementUI, {
  size: 'medium'
})

window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
